
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panel-private",
      function () {
        return require("private-next-pages/panel-private/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panel-private"])
      });
    }
  